rhm.dropdown_menu = (function (module) {
  'use strict';

  var classes = {
    selected: 'selected',
    activeMenu: 'active'
  };

  var selectors = {
    mobileMenu: '.dropdownListTrigger',
    list: '.dropdownList',
    trigger: '.dropdownList > li > a',
    back: '.dropdownList .dropBack > a',
    activeitem: 'li.selected',
    dropdown: '.dropdown',
    close: '.closeDropDown'
  };

  function onTriggerOpen(evt) {
    evt.preventDefault();
    var el = evt.currentTarget;
    var menu = el.getAttribute('data-dropdown');
    if (!menu) return;
    document.documentElement.classList.add('blockScroll');
    var panel = document.getElementById(menu);
    if (panel) panel.classList.add(classes.activeMenu);
  }

  function onCloseClick(evt) {
    evt.preventDefault();
    var el = evt.currentTarget;
    var menu = el.getAttribute('data-dropdown');
    if (!menu) return;
    document.documentElement.classList.remove('blockScroll');
    var panel = document.getElementById(menu);
    if (panel) panel.classList.remove(classes.activeMenu);
  }

  function onListClick(evt) {
    evt.stopPropagation();
  }

  function onParentClick(evt) {
    evt.preventDefault();
    var el = evt.currentTarget;
    var activeList = el.parentElement;
    if (!activeList) return;
    if (activeList.classList.contains(classes.selected)) {
      activeList.classList.remove(classes.selected);
      return;
    }
    var list = document.querySelector(selectors.list);
    if (list) {
      list.querySelectorAll(selectors.activeitem).forEach(function (node) {
        node.classList.remove(classes.selected);
      });
    }
    activeList.classList.add(classes.selected);
  }

  function onBackClick(evt) {
    evt.preventDefault();
    var el = evt.currentTarget;
    var li = el.closest(selectors.activeitem);
    if (li) li.classList.remove(classes.selected);
    return false;
  }

  document.querySelectorAll(selectors.mobileMenu).forEach(function (node) {
    node.addEventListener('click', onTriggerOpen);
    node.addEventListener('touchstart', onTriggerOpen, { passive: false });
  });

  document.querySelectorAll(selectors.list).forEach(function (node) {
    node.addEventListener('click', onListClick);
    node.addEventListener('touchstart', onListClick, { passive: false });
  });

  document.querySelectorAll(selectors.close).forEach(function (node) {
    node.addEventListener('click', onCloseClick);
    node.addEventListener('touchstart', onCloseClick, { passive: false });
  });

  document.querySelectorAll(selectors.trigger).forEach(function (node) {
    node.addEventListener('click', onParentClick);
    node.addEventListener('touchstart', onParentClick, { passive: false });
  });

  document.querySelectorAll(selectors.back).forEach(function (node) {
    node.addEventListener('click', onBackClick);
    node.addEventListener('touchstart', onBackClick, { passive: false });
  });

  module = {};
  return module;

}(rhm.dropdown_menu));
